import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ContratistaService } from 'src/app/services/contratista.service';
import { FacturacionService } from 'src/app/services/facturacion.service';
import { LicenciaService } from 'src/app/services/licencia.service';
import { LoginService } from 'src/app/services/login.service';


@Component({
  selector: 'app-menu-sidebar-contratista',
  templateUrl: './menu-sidebar-contratista.component.html',
  styleUrls: ['./menu-sidebar-contratista.component.scss']
})
export class MenuSidebarContratistaComponent implements OnInit {
  hidden = false;
  userLog:any
  licenciasActivas:any
  facturas:any

  toggleBadgeVisibility() {
    this.hidden = !this.hidden;
  }
  constructor(private contratistaService: ContratistaService, private apollo: Apollo, private loginService: LoginService, private facturaService: FacturacionService) { }

  ngOnInit(): void {
    this.userLog = this.loginService.getUserData()
 
    this.getLicenciasPagadas()
    this.getFacturasByContratista()
  }
  
  getLicenciasPagadas(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getContratistaById(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {

       this.licenciasActivas = data.contratista.licenciasPagadas
    
      })
  }

  getFacturasByContratista() {
    this.apollo.watchQuery<any>({
      query: this.facturaService.getFacturasByContratista(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {

        this.facturas = data.contratista.facturas.filter((factura:any)=>factura.estado == "invitacion")
        this.facturas = this.facturas.length
          }
      )
  }
  
  }


